"use client";

import RouteError from "@/components/RouteError";

export default function Error(props: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <RouteError
      {...props}
      boundary="numerology_route"
      message="We could not load the numerology calculator. Please try again."
    />
  );
}
